<template>
  <i
    class="md-icon"
    :class="css"
    v-html="html"
  />
</template>

<script>
let mdSVGStore = {}
export default {
  name: 'MdSVGLoader',
  props: {
    src: {
      type: String,
      required: true
    },
    css: {
      type: String,
      required: false
    }
  },
  data: () => ({
    html: null,
    error: null
  }),
  watch: {
    src () {
      this.html = null
      this.loadSVG()
    }
  },
  mounted () {
    this.loadSVG()
  },
  methods: {
    isSVG (mimetype) {
      return mimetype.indexOf('svg') >= 0
    },
    async setHtml (value) {
      this.html = await mdSVGStore[this.src]
      await this.$nextTick()
      this.$emit('md-loaded')
    },
    unexpectedError (reject) {
      this.error = `Something bad happened trying to fetch ${this.src}.`
      reject(this.error)
    },
    loadSVG () {
      if (!mdSVGStore.hasOwnProperty(this.src)) {
        mdSVGStore[this.src] = new Promise((resolve, reject) => {
          const request = new window.XMLHttpRequest()
          request.open('GET', this.src, true)
          request.onload = () => {
            const mimetype = request.getResponseHeader('content-type')
            if (request.status === 200) {
              if (this.isSVG(mimetype)) {
                resolve(request.response)
                this.setHtml()
              } else {
                this.error = `The file ${this.src} is not a valid SVG.`
                reject(this.error)
              }
            } else if (request.status >= 400 && request.status < 500) {
              this.error = `The file ${this.src} do not exists.`
              reject(this.error)
            } else {
              this.unexpectedError(reject)
            }
          }
          request.onerror = () => this.unexpectedError(reject)
          request.onabort = () => this.unexpectedError(reject)
          request.send()
        })
      } else {
        this.setHtml()
      }
    }
  }
}
</script>

<style lang="scss">
.md-icon {
  & > svg {
    fill: currentColor;
  }
}
</style>
